import { render } from "./Colorful.vue?vue&type=template&id=6a5ab6f8"
import script from "./Colorful.vue?vue&type=script&lang=js"
export * from "./Colorful.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__